let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f11F6")).then(() => parcelRequire('oUNja'));